// extracted by mini-css-extract-plugin
export default {"wrapper":"Lyric_wrapper__qVU5n","paragraph":"Lyric_paragraph__IIbkc","word":"Lyric_word__GDPYv","active":"Lyric_active__hB8VK"};